import { render } from "./AdminInvoicesTable.vue?vue&type=template&id=80cdfee0&ts=true"
import script from "./AdminInvoicesTable.vue?vue&type=script&lang=ts"
export * from "./AdminInvoicesTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__